class ProductVideosSequence extends HTMLElement {
  connectedCallback() {
    this.carousel = this.querySelector('scroll-carousel');
    this.items = [...this.querySelectorAll('.product-videos-accordion__item')];
    this.activeIndex = 0;
    this.details = this.closest('details');

    this.items.forEach((item, index) => {
      const videoMedia = item.querySelector('video-media');
      const videoElement = item.querySelector('video');

      videoMedia?.addEventListener('media:play', () => {
        this.activeIndex = index;
      });

      videoElement?.addEventListener('ended', () => {
        if (index === this.activeIndex) {
          this.#advance(index);
        }
      });
    });

    this.details?.addEventListener('toggle', () => {
      if (this.details.open && !window.matchMedia('(max-width: 999px)').matches) {
        this.#playAt(this.activeIndex);
      } else {
        this.#pauseAll();
      }
    });
  }

  #advance(fromIndex) {
    const nextIndex = fromIndex + 1;

    if (nextIndex >= this.items.length) {
      return;
    }

    this.#playAt(nextIndex);
  }

  #playAt(index) {
    const videoMedia = this.items[index]?.querySelector('video-media');
    const videoElement = videoMedia?.querySelector('video');

    if (!videoMedia) {
      return;
    }

    this.activeIndex = index;
    this.carousel?.select(index, { instant: false });

    if (videoElement) {
      videoElement.muted = true;
    }

    videoMedia.play({ restart: true });
  }

  #pauseAll() {
    this.items.forEach((item) => {
      item.querySelector('video-media')?.pause();
    });
  }
}

if (!window.customElements.get('product-videos-sequence')) {
  window.customElements.define('product-videos-sequence', ProductVideosSequence);
}
